import axios from "axios"

// import esriRequest from "@arcgis/core/request";

// export const postBugRequest = async(item:any)=>{
//     try {
//         let url= 'https://amd-midtier-staging.azurewebsites.net/api/contacts/contactitem'
//         let options:any={
//             body:item,
//             method:"post",
//             responseType:"json"
//         }
//         let res = await esriRequest(url,options)
//         return res.data
        
//     } catch (error) {
//         return error
//     }

// }


let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        processData: false,
        contentType: false,  
    }
};

export const postContactForm = async (item: any) : Promise<any> => {

    return new Promise((resolve, reject) =>{
        axios.post<any>(
            'https://amd-midtier-staging.azurewebsites.net/api/contacts/contactitem', item, axiosConfig
        )
        .then(response => {
            resolve(response)
        }).catch((err)=>{
            // reject(new Error("Something ugly went wrong."));
            resolve(new Error("Unable to send contact request"));
        })
    })
}